
import _ from 'lodash'
import moment from 'moment'

export const preferredUpdate = (
  prevValues,
  currentValues,
  currentState,
  self,
  key
) => {
  const prevIndex = []
  const currentIndex = []

  if (!prevValues) {
    return
  }

  prevValues.forEach((phone, index) => {
    if (phone?.preferred) {
      prevIndex.push(index)
    }
  })

  currentValues.forEach((phone, index) => {
    if (phone?.preferred) {
      currentIndex.push(index)
    }
  })

  const removeVal = val => val === prevIndex[0]

  _.remove(currentIndex, removeVal)

  const shouldUpdateState =
    prevIndex?.[0] >= 0 &&
    currentIndex?.[0] >= 0 &&
    prevIndex[0] !== currentIndex[0]

  if (!shouldUpdateState || !currentState?.[key]?.[prevIndex?.[0]] || !currentState?.[key]?.[currentIndex?.[0]]) {
    return
  }

  currentState[key][prevIndex[0]].preferred = false

  currentState[key][currentIndex[0]].preferred = true

  self.setState({
    value: { ...currentState }
  })
}

// Function for mapping selectable options to the select input
export const mapCodeForSelect = options =>
  options.map(o => ({
    ...o,
    label: o.display || o.label,
    value: o.code || o.value
  }))

// Function for setting empty array of values for form builder values
export const getOrEmpty = value => (_.isEmpty(value) ? [{}] : value)

// Function for escape key
export const escapeCancel = (event, func) => {
  if (event.keyCode === 27) {
    func()
  }
}

// Function for enter key
export const enterKey = (event, func) => {
  if (event.keyCode === 13) {
    func()
  }
}

export const today = moment()

export const humanName = (names, order = 'nameFirst') => {
  const nm = _.first(names)
  const given = _.compact(nm?.given).join(' ')
  const family = (_.isArray(nm?.family) && _.first(nm?.family)) || nm?.family
  if (order === 'nameFirst') {
    return [ given, family ].join(' ')
  }
  return [ family, given ].join(', ')
}

export const isBlank = val =>
  val === null ||
  // eslint-disable-next-line no-void
  val === void 0 ||
  val === '' ||
  val === false ||
  (Array.isArray(val) && val.length === 0)

export const removeBlanks = rootNode => {
  let atLeastOneKey
  let k
  let newNode

  if (typeof rootNode === 'object') {
    if (Array.isArray(rootNode)) {
      newNode = rootNode.map(e => removeBlanks(e))
      newNode = newNode.filter(e => !isBlank(e))
      if (isBlank(newNode)) {
        return null
      }
      return newNode
    }
    if (rootNode instanceof Date) {
      return rootNode
    }
    newNode = {}
    atLeastOneKey = false
    for (k in rootNode) {
      // eslint-disable-next-line no-prototype-builtins
      if (rootNode.hasOwnProperty(k)) {
        const v = rootNode[k]
        const newV = removeBlanks(v)
        if (!isBlank(newV)) {
          atLeastOneKey = true
          newNode[k] = newV
        }
      }
    }

    if (atLeastOneKey) {
      return newNode
    }
    return null
  }

  if (isBlank(rootNode)) {
    return null
  }

  if (typeof rootNode === 'string') {
    const trimmed = rootNode.trim()
    if (isBlank(trimmed)) {
      return null
    }
    return trimmed
  }

  return rootNode
}

export const removeBlanksKeepArray = rootNode => {
  let atLeastOneKey
  let k
  let newNode

  if (typeof rootNode === 'object') {
    if (Array.isArray(rootNode)) {
      newNode = rootNode.map(e => removeBlanksKeepArray(e))
      if (isBlank(newNode)) {
        return null
      }
      return newNode
    }
    if (rootNode instanceof Date) {
      return rootNode
    }
    newNode = {}
    atLeastOneKey = false
    for (k in rootNode) {
      // eslint-disable-next-line no-prototype-builtins
      if (rootNode.hasOwnProperty(k)) {
        const v = rootNode[k]
        const newV = removeBlanksKeepArray(v)
        if (!isBlank(newV)) {
          atLeastOneKey = true
          newNode[k] = newV
        }
      }
    }

    if (atLeastOneKey) {
      return newNode
    }
    return null
  }

  if (isBlank(rootNode)) {
    return null
  }

  if (typeof rootNode === 'string') {
    const trimmed = rootNode.trim()
    if (isBlank(trimmed)) {
      return null
    }
    return trimmed
  }

  return rootNode
}
